import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Container, Typography, Box, TextField, Button, CircularProgress, Snackbar,
} from '@mui/material';
import { motion } from 'framer-motion';
import axios from 'axios';

const ReportIndiscipline = () => {
  const { state } = useLocation();
  const { learnerId, learnerName, schoolId } = state || {};
  const navigate = useNavigate();

  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleSubmit = async () => {
    if (!description.trim()) {
      setSnackbar({ open: true, message: 'Please enter a description of the indiscipline case', severity: 'error' });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        'https://kidsm.vercel.app/api/schools/report-indiscipline',
        {
          learnerId,
          description,
          schoolId,
        }
      );

      if (response.data.success) {
        setSnackbar({ open: true, message: 'Indiscipline case reported successfully', severity: 'success' });
        setTimeout(() => navigate(-1), 2000);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || 'Failed to report case',
          severity: 'error',
        });
      }
    } catch (error) {
      console.error('Error reporting indiscipline:', error);
      setSnackbar({
        open: true,
        message: 'Failed to report indiscipline case',
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  if (!learnerId || !learnerName || !schoolId) {
    return (
      <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#e74c3c' }}>
          Error: Missing required parameters
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 2, textAlign: 'center' }}>
          Report Indiscipline Case
        </Typography>
        <Typography sx={{ fontSize: '1.125rem', color: '#6200ee', fontWeight: 'bold', mb: 4, textAlign: 'center' }}>
          Student: {learnerName}
        </Typography>

        <Typography sx={{ fontSize: '1rem', color: '#333', mb: 2 }}>
          Description of the case:
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={6}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Describe the indiscipline case in detail..."
          sx={{ bgcolor: '#fff', borderRadius: 2, mb: 4 }}
          variant="outlined"
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            bgcolor: '#ff5722',
            borderRadius: 2,
            py: 1.5,
            textTransform: 'none',
            fontWeight: 'bold',
            '&:hover': { bgcolor: '#e64a19' },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit Report'}
        </Button>
      </motion.div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{ bgcolor: snackbar.severity === 'success' ? '#4CAF50' : '#e74c3c' }}
      />
    </Container>
  );
};

export default ReportIndiscipline;